import CompletePermitModal from "../components/CompletePermitModal";
import { Document } from "../models/Document";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  submitInProgress: boolean;
  showAsBuilt?: boolean;
  documents?: Document[];
  onAsBuiltAdded?: () => void;
  showGisDeclaration: boolean;
  asBuiltCompletionDeclarations?: string[] | null;
}

const CompletePermitModalContainer = ({
  open,
  onClose,
  onSubmit,
  submitInProgress,
  showAsBuilt,
  documents,
  onAsBuiltAdded,
  showGisDeclaration,
  asBuiltCompletionDeclarations,
}: Props) => {
  return (
    <CompletePermitModal
      title="Completion review"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      submitInProgress={submitInProgress}
      showAsBuilt={showAsBuilt}
      documents={documents}
      onAsBuiltAdded={onAsBuiltAdded}
      showGisDeclaration={showGisDeclaration}
      asBuiltCompletionDeclarations={asBuiltCompletionDeclarations}
    ></CompletePermitModal>
  );
};

export default CompletePermitModalContainer;

